/*
 * Behavior related to videos.
 */
var VideoController = (function ($) {
  
  function ready() {
    $("a.video").each(function () {
      var a = $(this);
      a.append("<span class='video-play' />");
      });
    $("div.video").each(function () {
        var a = $(this);
        a.append("<span class='video-play' />");
    });
  }
  
  $(ready);
  
})(jQuery);